import React from 'react'

export default function FundRepayment() {
    return (
        <div>
            <p>This is fund repayment</p>
        </div>
    )
}
